import { useEffect, useState } from 'react'
import { Helmet, HelmetTags } from 'react-helmet'
import { useIsP2IAPage } from '../../compagnon/routers/useIsP2IA'
import { MUNCHKIN_ID } from '../../config'
import { useUTMCookies } from '../../cookies/useUTMCookies'
import { useIsUserInFrance } from '../../i18n/france'

export const MunchkinCookie = () => {
  const [didInit, setDidInit] = useState(false)
  const [isScriptLoaded, setIsScriptLoaded] = useState(false)
  const isUserInFrance = useIsUserInFrance()
  const isP2IAPage = useIsP2IAPage()
  useUTMCookies(didInit)

  useEffect(() => {
    if (
      isScriptLoaded &&
      !didInit &&
      isUserInFrance !== null &&
      !isUserInFrance &&
      !isP2IAPage &&
      MUNCHKIN_ID
    ) {
      window.Munchkin.init(MUNCHKIN_ID)
      setDidInit(true)
    }
  }, [isScriptLoaded, isUserInFrance, didInit, isP2IAPage])

  const onScriptInjection = (_newState: HelmetTags, scriptTags: HelmetTags) => {
    if (scriptTags !== undefined && scriptTags.scriptTags !== undefined) {
      const scriptTag = scriptTags.scriptTags[0]
      scriptTag.onload = () => {
        setIsScriptLoaded(true)
      }
    }
  }

  return (
    <Helmet
      script={[{ src: '//munchkin.marketo.net/munchkin.js' }]}
      // Helmet doesn't support `onload` in script objects so we have to hack in our own
      // https://github.com/nfl/react-helmet/issues/146
      onChangeClientState={onScriptInjection}
    />
  )
}
